import BaseFormatter from "./Format";

export class Translator {

    lang: string = "pl";
    fmt: BaseFormatter = new BaseFormatter();
    messages:any =  { "pl": {}, "gb": {}, "de": {}, "ua": {} }

    constructor(lang: string, translations:any[]) {
        this.lang = lang;
        this.messages=this.init(lang, translations)
    }

    public t(key: string, values?: any): string {

        const m = (<any>this.messages);
        if (!values) values=[]
        const mm=m[this.lang]
        const txt: string = mm[key] // key='ceny'
        if (!txt) { 
            console.error("Brak tłumaczenia dla klucza",key)
            return key;
        }

        //console.log("txt",txt,"key >"+key+"<", values[0], values[1])
        const arr: any[] = this.fmt.interpolate(txt, values);
        let s: string = ""
        for (let i = 0; i < arr.length; i++) {
            s += arr[i]
        }
        return s;
    }


    init(lang: string, translations:any[]) {
        const m: any = { "pl": {}, "gb": {}, "de": {}, "ua": {} }

        for (let i=0;i<translations.length;i++) {
            const t:any=translations[i]
            m[t.lang][t.key.trim().replace('"','').replace('"','')] = t.txt
        }

        return m;
    }


}